export enum SituacaoCarregamento {
  ATIVO = 'Ativo',
  PENDENTE = 'Pendente',
  CANCELADO = 'Cancelado',
  FINALIZADO = 'Finalizado',
}
